import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ToDateJalali, RenderPrice } from "../../../Common/Function/index";
function Cards({ item }) {
  const dispatch = useDispatch();
  const renderType = type => {
    switch (type) {
      case "online":
        return "آنلاین";
      case "offline":
        return "آفلاین";
      default:
        break;
    }
  };
  const handlerOffer = data => {
    const { price } = data;
    if (data.second_price) {
      let a = price - data.second_price;
      let x = (100 * a) / price;
      return (
        <label
          className="ClassLabel offerClassLabel m-2 position-absolute  "
          style={{ top: 0, left: "1px" }}
        >
          تخفیف {x} درصدی
        </label>
      );
    }
  };

  return (
    <div
      className="card mb-3 "
      style={{
        overflow: "hidden",
      }}
    >
      <Link to={`/Classes/Single/${item.slug}`}>
        <div className="row no-gutters">
          <div className="col-md-4 p-0 order-md-2 order-2">
            <img
              className="card-img-top classImage"
              src={item.images && item.images[0]}
              alt="Card image cap"
              style={{
                maxHeight: "268px",
                objectFit: "cover",
              }}
            />
            <div>{handlerOffer(item.price)}</div>
          </div>
          <div className="col-md-8 order-md-1 order-2">
            <div className="row no-gutters ">
              <div
                className="col-md-4 class-none-inmd"
                style={{
                  borderLeft: "1px solid #404040",
                  borderColor: "rgba(64,64,64,0.15)",
                }}
              >
                <div className="d-flex flex-column">
                  <div
                    id="carouselExampleControls"
                    className="carousel slide"
                    data-ride="carousel"
                  >
                    <div className="carousel-inner">
                      {item &&
                        item.teachers &&
                        item.teachers.map((teach, i) => {
                          return (
                            <div
                              key={i}
                              className={`carousel-item ${
                                i === 0 ? "active" : ""
                              }`}
                            >
                              <img
                                className="d-block w-100 object-fit-cover"
                                src={teach.image[0]}
                                alt={`${i}مربی`}
                                height={"150px"}
                                style={{ borderRadius: "5px" }}
                              />
                              <div className="d-flex flex-column justify-content-center align-items-center ">
                                <span> نام مربی : {teach.name}</span>
                                <span>مدرک : {teach.proof}</span>
                                <span> سابقه : {teach.activity + " "}سال </span>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <div>
                    <button className="btn  py-3 d-flex flex-column align-items-center cutumBorder infoLabel ">
                      <i
                        className="far fa-file-alt"
                        style={{ fontSize: "20px" }}
                      />
                      اطلاعات و نظرات
                    </button>
                  </div>
                  <h5 className="titleClassInfo card-title">{`کلاس ${renderType(
                    item.type
                  )} ${item.name} `}</h5>

                  <div></div>
                  <div className="mt-1">
                    <span
                      style={{
                        fontWeight: 500,
                      }}
                    >
                      نوع برگزاری :
                    </span>
                    <span
                      style={{
                        fontWeight: 500,
                        marginRight: "5px",
                      }}
                    >
                      {renderType(item.type)}
                    </span>
                  </div>
                  <div className="mt-1">
                    <span
                      style={{
                        fontWeight: 500,
                      }}
                    >
                      تعداد جلسات :
                    </span>
                    <span
                      style={{
                        fontWeight: 500,
                        marginRight: "5px",
                      }}
                    >
                      {item.count_session} جلسه
                    </span>
                  </div>
                  <div>
                    <span
                      style={{
                        fontWeight: 500,
                      }}
                    >
                      تاریخ شروع :
                    </span>
                    <span
                      style={{
                        fontWeight: 500,
                        marginRight: "5px",
                      }}
                    >
                      {ToDateJalali(item.start_date)}
                    </span>
                  </div>
                  <div className="row mt-3 justify-content-between">
                    <div className="col d-flex align-items-center justify-content-center">
                      <span style={{ marginLeft: "5px" }}>{item.capacity}</span>
                      <i className="fas fa-users"></i>
                    </div>
                    <div className="col d-flex align-items-center justify-content-center">
                      <span style={{ marginLeft: "5px" }}>0</span>
                      <i className="fas fa-comment-alt"></i>
                    </div>
                    <div className="col d-flex align-items-center justify-content-center">
                      <span style={{ marginLeft: "5px" }}>
                        {item.comments_avg_score == null
                          ? "5"
                          : item.comments_avg_score}
                      </span>
                      <i className="fas fa-star"></i>
                    </div>
                  </div>
                  <div className="row mt-2">
                    <div>
                      <Link
                        onClick={() => {
                          dispatch({
                            local_storage: {
                              key: "classData",
                              value: item,
                            },
                            type: "SET",
                            payload: { classData: item },
                          });
                        }}
                        to={`/Classes/ClassOrder/${"registeForme"}`}
                      >
                        <label className="m-2 ClassLabel priceClassLabel w-100 text-center">
                          {RenderPrice(item.price)}
                        </label>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
export default Cards;
